// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { ReactComponent as Twitter } from '../../assets/svg/twitter.svg';
import { SocialMediaButton } from '../../styled-components/shared';

const Icon = styled(Twitter)`
  width: 1.5em;
  height: 1.5em;
`;
type Props = {
  className?: string;
  text: string;
};

const TwitterButton = ({ text, className }: Props) => {
  const shareUrl = `https://twitter.com/intent/tweet?external=1&text=${encodeURIComponent(text)}`;
  return (
    <a className={className} href={shareUrl} target="_blank" rel="noopener noreferrer">
      <SocialMediaButton>
        <Icon />
      </SocialMediaButton>
    </a>
  );
};

export default TwitterButton;
